import {procedures} from '@mep/pae-commons';
import isEmpty from 'lodash/isEmpty';

const {PROCEDURE_TYPES} = procedures;

const limpiarObjeto = (obj) => {
  for (let prop in obj) {
    if (obj[prop] === null || obj[prop] === undefined) {
      delete obj[prop];
    } else if (typeof obj[prop] === 'object') {
      limpiarObjeto(obj[prop]); // llamada recursiva
      if (Object.keys(obj[prop]).length === 0) {
        delete obj[prop]; // eliminar propiedad vacía
      }
    }
  }
  return obj;
};

const updateOrganizationGroupBasedOnPartners = (payload, data, process = []) => {
  const fields = ['administrationControl', 'inspectionControl'];
  //
  if (process?.includes(PROCEDURE_TYPES.CHANGE_ADMINISTRATION_CONTROL_BODY)) {
    const data = payload?.dataByProcess?.[PROCEDURE_TYPES.CHANGE_ADMINISTRATION_CONTROL_BODY];
    if (data) {
      const partners = data?.partners || data?.partners;
      fields?.forEach((field) => {
        if (!data?.[field]) {
          const existRepresentative = partners?.some(p => p?.idNumber === data?.[field]?.representative?.idNumber);
          const members = data?.[field]?.members?.filter(e => partners?.some(p => p?.idNumber === e?.idNumber));
          data[field] = {
            representative: existRepresentative ? data?.[field]?.representative?.idNumber : null,
            members: !isEmpty(members) ? members : []
          };
        }
      });
    }
  }
  return payload;
};

export {
  limpiarObjeto,
  updateOrganizationGroupBasedOnPartners
};
